import * as React from 'react';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { createStyles, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { GetString } from '../StringResourceManager';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import { isMatch } from '../../utils/textMappings';
import DynamicComboBox from '../DynamicComboBox';

const useStyles = makeStyles(() =>
  createStyles({
    statusValueInput: { width: '250px', minWidth: '5%' },
    statusCategoryInput: { width: '250px', minWidth: '5%', marginLeft: 10 },
  })
);

export const CustomErrorStateFilter = (props: any) => {
  const classes = useStyles();

  const currentIssueCategories: string[] = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.currentIssueCategories
  );

  const onStatusChange = (event: any) => {
    props.onFilterChange.call(undefined, {
      nextFilter: {
        ...props.filter,
        value: {
          Value: getValueKey(event.target.value),
          Category: props.filter.value?.Category ?? '',
          Label: event.target.value,
        },
      },
    });
  };

  const onCategoryChange = (event: any) => {
    props.onFilterChange.call(undefined, {
      nextFilter: {
        ...props.filter,
        value: {
          Value: props.filter.value?.Value ?? '',
          Category: event.target.value,
          Label: props.filter.value?.Label ?? '',
        },
      },
    });
  };

  const getValueKey = (value: any) => {
    if (isMatch('WARNING', value))
      return ApiEnums.DeviceStatus.Inconvenienced.toString();
    else if (isMatch('ERROR', value))
      return ApiEnums.DeviceStatus.Error.toString();
  };

  return (
    <React.Fragment>
      <DynamicComboBox
        className={classes.statusValueInput}
        onChange={onStatusChange}
        data={[GetString('WARNING'), GetString('ERROR')]}
        value={props.filter?.value?.Label ?? ''}
        placeholder={GetString('FIELD_STATUS_LABEL')}
      />
      <DynamicComboBox
        className={classes.statusCategoryInput}
        onChange={onCategoryChange}
        data={currentIssueCategories}
        value={props.filter?.value?.Category ?? ''}
        placeholder={GetString('CATEGORY_PLACEHOLDER')}
      />
    </React.Fragment>
  );
};
